module.exports = __webpack_public_path__ + "static/media/03 Generali produkcja zwierzęca Ustandaryzowany dokument.06460e95.pdf";